import { showPhase } from "./phase";
import { isFullDataForm } from "../main";
import { timeoutToExit } from "./exit";

export let isRetryingPayment = false

export const retryingPayment = () => {
    if(isFullDataForm) {
        showPhase('Oneform')
    } else {
        showPhase('Payment');
    }

    isRetryingPayment = true

    clearTimeout(timeoutToExit)
}